<template>
  <div>
    <!-- <el-button class="button absolute_center" @click="dutyScience"></el-button> -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
//import { initScene } from "./science.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {},
  data() {
    //这里存放数据
    return {};
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.dutyScience();
  },
  //方法集合
  methods: {
    dutyScience() {
      if (bmeConfig.mapType !== "3D") return;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      let that = this;
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        const earth = window.g_bme3dManager.earth;
        //initScene(earth);
      } else {
        that.timer = setTimeout(function () {
          that.dutyScience();
        }, 5000);
      }
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.button {
  width: 30px;
  height: 30px;
  background-color: red;
  pointer-events: all;
}
</style>
